import AccountsView from './AccountsView';
import LimitsView from './LimitsView';
import React, { useState } from 'react';

export default function Calc() {
    const [active, setActive] = useState('accounts');
    
    return (
        <div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                <button
                    onClick={() => setActive('accounts')}
                    disabled={active === 'accounts'}
                >
                    Հաշիվներ
                </button>

                <button
                    onClick={() => setActive('limits')}
                    disabled={active === 'limits'}
                >
                    Լիմիտներ
                </button>
            </div>

            {active === 'accounts' && <AccountsView />}
            {active === 'limits' && <LimitsView />}
        </div>
    );
}